import axiosInstance from "./axiosInstance";

export const fetchWasteReportConfig = () => axiosInstance.get("/waste-reports/config");

export const fetchWasteReports = (status = "") => (
    axiosInstance.get("/waste-reports", { params: status ? { status } : {} })
);

export const createWasteReport = (formData) => (
    axiosInstance.post("/waste-reports", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    })
);

export const approveWasteReport = (id) => (
    axiosInstance.patch(`/waste-reports/${id}/approve`)
);

export const rejectWasteReport = (id) => (
    axiosInstance.patch(`/waste-reports/${id}/reject`)
);
